const Storage = {
  save: (key: string, value: any) => {
    let data = { key, value };
    sessionStorage.setItem(key, JSON.stringify(data));
    return Storage;
  },
  get: (key: string) => {
    const value = sessionStorage.getItem(key);
    if (value) {
      return JSON.parse(value).value;
    }
    return null;
  },
  delete: (...args: string[]) => {
    args.forEach((item) => {
      sessionStorage.removeItem(item);
    });
  },
  clearAll: () => {
    sessionStorage.clear();
  },
  cache: {
    set: (key: string, value: any, expires?: number) => {
      let data = { key, value };
      if (expires) {
        data = Object.assign(data, { time: expires + new Date().getTime() });
      }
      localStorage.setItem(key, JSON.stringify(data));
    },
    get: (key: string) => {
      const data = localStorage.getItem(key);
      if (data) {
        const jsonData = JSON.parse(data);
        if (jsonData?.time && new Date().getTime() > jsonData.time) {
          return null;
        }
        return jsonData.value;
      }
      return null;
    },
    clearAll: () => {
      localStorage.clear();
    },
  },
};

export default Storage;
